var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard",attrs:{"id":"app"}},[_c('div',{staticClass:"content"},[_c('app-header'),_c('app-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }